<template>
  <div class="animations-wrapper">
    <ul class="animations-list">
      <li
        class="animations-item"
        v-for="(item, key) in data"
        :class="[
          { relative: key === 0 },
          startAnimation ? 'animated' : '',
          item.type && item.type === 'mask' ? 'animations-item-mask' : '',
          item.maskDirection ? item.maskDirection : '',
          item.customClasses,
        ]"
        :style="`${
          'transition-duration:' +
          (item.duration ? item.duration + 's;' : 0.6 + 's;') +
          's; ' +
          'transition-delay:' +
          (item.delay ? item.delay + 's;' : 0.35 * (key + 1) + 's;') +
          item.customStyles
        }`"
        :key="key"
      >
        <img
          class="animations-img"
          :src="item.src"
          :style="item.customStylesImage"
          :alt="item.altText"
        />
      </li>
    </ul>
  </div>
</template>

<script>
// plugins
import { ScrollTrigger } from "gsap/ScrollTrigger";

// vuex
import { mapState } from 'vuex';

export default {
  name: "GraphicAnimation",
  props: {
    data: {
      type: [Array, Object],
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      startAnimation: false,
    };
  },
  computed: {
    // vuex module, that has info about browser, window sizes etc.
    ...mapState(["UserAgent"]),
  },
  methods: {
    initScene() {
      if(this.UserAgent.browser.name !== 'ie') {
        ScrollTrigger.create({
          trigger: this.$el,
          start: "top bottom-=10%",
          onEnter: () => {
            this.startAnimation = true;
          },
        });
      }

      // disabled animation on screentest-mode or on ie
      if (this.$route.query.screentest || this.UserAgent.browser.name === 'ie' || window.innerWidth < 512) {
        this.startAnimation = true;
      }
    },
  },
  mounted() {
    this.initScene();
  },
};
</script>

<style lang="scss">
.animations-list {
  position: relative;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.animations-item {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;

  &.animated {
    opacity: 1;
  }

  &.relative {
    position: relative;
  }
}

.animations-img {
  width: 100%;
  height: auto;
}

.animations-item-mask {
  overflow: hidden;
  opacity: 1;

  .animations-img {
    transition: inherit;
  }

  &.fromLeft {
    transform: translate3d(-100%, 0, 0);

    .animations-img {
      transform: translate3d(100%, 0, 0);
    }

    &.animated {
      transform: translate3d(0, 0, 0);

      .animations-img {
        transform: translate3d(0, 0, 0);
      }
    }
  }

  &.fromRight {
    transform: translate3d(100%, 0, 0);

    .animations-img {
      transform: translate3d(-100%, 0, 0);
    }

    &.animated {
      transform: translate3d(0, 0, 0);

      .animations-img {
        transform: translate3d(0, 0, 0);
      }
    }
  }

  &.fromTop {
    transform: translate3d(0, -100%, 0);

    .animations-img {
      transform: translate3d(0, 100%, 0);
    }

    &.animated {
      transform: translate3d(0, 0, 0);

      .animations-img {
        transform: translate3d(0, 0, 0);
      }
    }
  }

  &.fromBottom {
    transform: translate3d(0, 100%, 0);

    img {
      transform: translate3d(0, -100%, 0);
    }

    &.animated {
      transform: translate3d(0, 0, 0);

      img {
        transform: translate3d(0, 0, 0);
      }
    }
  }
}

// disabled animation on screentest-mode
.screentest .animations-img,
.screentest .animations-item-mask {
  transition-delay: 0s !important;
  transition-duration: 0s !important;
  transform: translate3d(0, 0, 0) !important;
  opacity: 1 !important;
}
</style>
